export const linkedin_color = () => (
  <>
    <path
      d="M21.4066 1H2.65838C1.76162 1 1 1.70924 1 2.58295V21.416C1 22.2908 1.49971 23 2.39648 23H21.1447C22.0425 23 23 22.2908 23 21.416V2.58295C23 1.70924 22.3044 1 21.4066 1Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#0A66C2"
    />
    <path
      d="M12.3426 9.38095H9.38095V19.8571H12.5238V14.8254C12.5238 13.0696 13.277 12 14.8569 12C16.158 12 16.7143 13.2226 16.7143 14.6159V19.8571H19.8571V14.0429C19.8571 10.9304 18.974 9.25 15.8091 9.25C14.1602 9.25 12.8266 10.0766 12.375 10.8906H12.3426V9.38095Z"
      fill="white"
    />
    <path
      d="M7.28571 19.8571H4.14286V9.38095H7.28571V19.8571Z"
      fill="white"
    />
    <path
      d="M5.71429 7.67857C6.79962 7.67857 7.67857 6.79962 7.67857 5.71429C7.67857 4.62895 6.79962 3.75 5.71429 3.75C4.62895 3.75 3.75 4.62895 3.75 5.71429C3.75 6.79962 4.62895 7.67857 5.71429 7.67857Z"
      fill="white"
    />
  </>
);
